var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3873(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3873",
    "data-name": "Group 3873",
    transform: "translate(24) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_39426",
    "data-name": "Ellipse 39426",
    fill: "#fff",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-expand-arrow",
    d: "M5.632,2.586,1.811,6.407a1.061,1.061,0,0,1-1.5,0h0a1.061,1.061,0,0,1,0-1.5L4.924.293a1,1,0,0,1,1.414,0l4.614,4.614a1.061,1.061,0,0,1,0,1.5h0a1.061,1.061,0,0,1-1.5,0Z",
    transform: "translate(7.5 17.5) rotate(-90)",
    fill: "#6f6f6f",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3873);
export default __webpack_public_path__ + "static/media/Group 3873.8448c47aad3bd7070e96bd94dc3da847.svg";
export { ForwardRef as ReactComponent };